var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"layout-header"},[_vm._t("default"),_c('div',{staticClass:"layout-header-extra"},[_vm._t("extra")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }